/* global angular */
require([
  "share",
  "application",
  "sticky-header",
  "comments/package",
  "filters"
], function(Share, app) {

  //initialize the share button
  new Share(".share-button", {
    ui: {
      flyout: "bottom left"
    },
    networks: {
      email: {
        enabled: true,
        description: "http://projects.seattletimes.com/washington-liquor-library"
      }
    }
  });

  app.controller("drinksTable", ["$scope", "$location", "$timeout", function($scope, $location, $timeout) {

    $scope.drinks = window.drinksData;
    $scope.recipes = window.recipesData;

    $scope.$on("$locationChangeSuccess", function() {
      var hash = $location.hash();
      var split = hash.split("-");
      $scope.type = split[0] || "Gin";
      if (!hash) return;
      //check for internal links
      $timeout(function() {
        var selector = '[id="#' + hash + '"]';
        var element = document.querySelector(selector);
        if (element) {
          var bounds = element.getBoundingClientRect();
          var scroll = document.body.scrollTop || document.documentElement.scrollTop;
          document.body.scrollTop = document.documentElement.scrollTop = bounds.top - 80 + scroll;
        }
      });
    });

    $scope.categories = [
      {
        label: "Gin",
        key: "Gin",
        available: true
      },
      {
        label: "Vodka",
        key: "Vodka",
        available: true
      },
      {
        label: "Whiskey",
        key: "Whiskey",
        available: true
      },
      {
        label: "Other",
        key: "Other"
      },
      {
        label: "Mixers",
        key: "Mixer"
      },
      {
        label: "Recipes",
        key: "Recipes"
      },
      {
        label: "Search all",
        key: "All"
      }
    ];

    $scope.availableTypes = $scope.categories.filter(function(d) { return d.available }).map(function(d) { return d.key });
    $scope.city = "All";
    $scope.recipeFilter = {
      Gin: true,
      Vodka: true,
      Whiskey: true,
      Other: true,
      Mixer: true
    };

    var cities = {};
    window.drinksData.forEach(function(row) {
      cities[row.city] = true;
    });
    $scope.cityList = Object.keys(cities).filter(function(d) { return d }).sort();
    $scope.cityList.unshift("All");

    $scope.setType = function(type) {
      $scope.type = type;
      $location.hash(type);
    };

  }]);

  angular.bootstrap(document.body, ["liquor-project"]);

});

define("main", function(){});

